import httpClient from './httpClient'

// TODO: utilsにrequestsとか作って見通しをよくしたい。
// 今のメリット：簡単
// 今のデメリット: configを毎回書く面倒さ・とにかく面倒・長い

export default {

    // キー認証
    async certifyAuhtKey(authKey) {
        const params = {
            authKey: authKey,
            service: 'devereach'
        }

        return httpClient.post('/auth/key', params).catch(error => error.response || error)
    },

    // Eメールログイン
    async loginByEmail(profile) {
        const params = {
            email: profile.email,
            password: profile.password,
            service: 'devereach'
        }

        return httpClient.post('/auth/login', params).catch(error => error.response || error)
    },
    // Oauthから取得したプロフィールをもとに新規登録 or ログイン処理を行う
    async loginByOauth(profile) {
        const params = {
            id: profile.id,
            first_name: profile.firstName,
            last_name: profile.lastName,
            name: profile.name,
            email: profile.email,
            picture: profile.picture,
            access_token: profile.accessToken,
            provider: profile.provider,
            service: 'devereach'
        }

        return httpClient.post('/auth/social/login', params).catch(error => error.response || error)
    },
    // ユーザーを取得
    async getUser() {
        return httpClient.get('/auth/profile').catch(error => error.response || error)
    },

    // ログアウト
    async logout() {
        return httpClient.post('/auth/logout').catch(error => error.response || error)
    },

    // 認証キーを取得する
    async fetchAuthKey(token) {
        return httpClient.get('/auth/key', {
            params: {
                token: token
            }
        }).catch(error => error.response || error)
    },

    /** Stripe */
    // サブスクリプション決済
    async pay(id) {
        const params = {
            id: id
        };

        return httpClient.post(`devereach/stripe/pay`, params)
            .catch(error => error.response || error);
    },

    // サブスクリプション解約
    async cancel(id) {
        return httpClient.post('devereach/stripe/cancel', {
            id: id,
            type: 'DEVEREACH'
        }).catch(error => error.response || error)
    },
    
    // ユーザー登録
    async register(profile) {
        return httpClient.post('/auth/register', {
            profile: profile,
            type: 'DEVEREACH'
        }).catch(error => error.response || error)
    },

    // パスワードリセット申請
    async requestResetPassword(email) {
        return httpClient.post('/auth/requestResetPassword', {
            email: email,
            type: 'DEVEREACH'
        }).catch(error => error.response || error)
    },

    // パスワード更新
    async updatePassword(profile) {
        return httpClient.post('/auth/updatePassword', {
            id: profile.id,
            password: profile.password
        }).catch(error => error.response || error)
    }
}